<template>
  <section class="why">
    <div class="container">
      <a-typography-title :level="1">
        为什么选择SchedulX?
      </a-typography-title>
      <a-row :gutter="[20,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :xl="6">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <p v-for="v in item.text">
                {{ v }}
              </p>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_worth',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '开放中立',
            text: [
              '核心组件开放源代码',
              '统一资源管理，屏蔽云平台差异'
            ]
          },
          {
            title: '降本增效',
            text: [
              '快速部署、灵活调度',
              '深度落地成本优化方案',
              '全流程自动化，提升工作效率'
            ]
          },
          {
            title: '安全稳定',
            text: [
              '系统本地化部署',
              '高可用部署保障稳定性'
            ]
          },
          {
            title: '灵活可扩展',
            text: [
              '兼容第三方标准产品',
              '支持二次开发'
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productSchedulX/';

.why {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{image}why_bg.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_white, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  position: relative;
  padding: 20px 20px;
  background: @color_white;
  border-radius: 8px;
  .shadow(0 0 15px fade(@color_black, 10));
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      &::before {
        .bg('@{image}why_icon_@{i}.png', 220px, 130px, true);
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    margin: 0 auto;
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    min-height: 78px;
    margin: 20px 0 0;
    .font(justify, @text+@line, @color_13, @text);
    
    p {
      position: relative;
      max-width: 250px;
      padding-left: 15px;
      margin: 0 auto;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 12px, auto, auto, 0);
        width: 4px;
        height: 4px;
        background: @color_6;
        border-radius: 50%;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .why {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_white, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    padding: 20px;
    
    .loop(@i) when (@i<=4) {
      &.i_@{i} {
        &::before {
          @scale: 0.5;
          .bg('@{image}why_icon_@{i}.png', 220px*@scale, 130px*@scale, true);
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      min-height: auto;
      margin: @margin_mo 0 0;
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>